
var wsod_chart = function(){};
wsod_chart.SELECTED_CLASS = "selected";
wsod_chart.BUFFER_URL = "api/";
wsod_chart.$container = null;
wsod_chart.selectedMultiTimeframe = null;
wsod_chart.priceAnnDates = null;
/*Basic Chart Rollovers*/
function wsod_InitializeChartRollovers(chartType, data, eventId, eventPopupId, chartId)
{
	wsod_chart.priceAnnDates = data;
	var manager = wsod_InitializeChartRollovers.GetManager();
	manager[chartType] = new wsod_chartrollovers();
	manager[chartType].InitializePopups(data, eventId, eventPopupId, chartId);
	wsod_InitializeChartRollovers._manager = manager;
};


wsod_chartrollovers = function() { };

(function($) {
	//Basic Chart Functions
	wsod_chart.init = function() {
		wsod.dependsOn("initTimeframeMenu", [
		function(ev, tf) { wsod_chart.ChangeTimeframe(ev, tf) } ]);
	};


	wsod_chart.ChangeTimeframe = function(ev, tf) {
		wsod_chart.ChangeDurationByElement(ev.currentTarget.parentNode, tf);
    };
    wsod_chart.ChangeDurationByElement = function(el, timeframe) {
		var $el = $(el);
		if ($el.hasClass(this.SELECTED_CLASS)) {
			var $parent = $el.parents(".chartDefinition");
			//var section = $el.attr("section");
			var chartDefinition = this.RetrieveChartDefinition($parent, $el, timeframe);

			var args = {
				$el: $el
				, $parent: $parent
				, def: chartDefinition
			};
			var id = chartDefinition.id;

			if ($parent.hasClass("multiChartDef")) {
				this._HandleMultiChartCall(args);
			} else {
				this._HandleSingleChartCall(args);
			}
		}
	};

    wsod_chart._HandleSingleChartCall = function(args) {
		this.$container = args.$el.parents(".inner").find(".content img.cht-image");
		this.HandleSelectedTimeframe(args.$parent, args.$el);
		wsod.showAjaxLoader(this.$container);
		wsod.load(args.def.json, this.BUFFER_URL + args.def.charttype, this._HandleRequest, this._HandleRequestError, this);
	};
    wsod_chart._HandleMultiChartCall = function(args) {
		var chartDef = args.def;
		var json = args.def.json;
		var aSymbols = [];
		var section = json.timeframe;

		var $chartContainers = $("div.chartContainer");
		var $defContainers = $chartContainers.find("div.chartDefinition");

		$defContainers.each(function() {
			var symbol = $(this).attr("chartsymbol");
			aSymbols.push(symbol);
		});
		wsod_chart.HandleSelectedTimeframe($defContainers, $defContainers.find("li[timeframe=" + section + "]"));

		this.$container = $chartContainers.find(".chartImg");

		this.$container.each(function() {
			wsod.showAjaxLoader(this);
		});

		json.symbols = aSymbols;
		wsod.load(json, this.BUFFER_URL + args.def.charttype, this._HandleMultiRequest, this._HandleRequestError, this);
	};
    wsod_chart._HandleMultiRequest = function(json_data, status) {
		if (json_data.src) {
			var counter = 0;
			this.$container.each(function() {
				var $el = $(this);
				$el.css({
					"background-image": "url(" + json_data.src + ")",
					"background-position": "0px " + ($el.height() * counter) + "px"
				});
				counter--;
				wsod.hideAjaxLoader(this);
			});
		}
	};
    wsod_chart._HandleRequest = function(json_data, status) {

		var eventId = "wsod_announcementRollover";
		var popupId = "wsod_announcementPopup";
		var chartId = "wsod_performanceChart";

		if (json_data.src) {
			this.$container.attr("src", json_data.src);
			wsod.hideAjaxLoader(this.$container);
		}

		if (json_data.label) {
			var $label = $("#wsod_label-" + json_data.type);
			$label.html(json_data.label);
		}
		if (json_data.data) {
			var manager = wsod_InitializeChartRollovers.GetManager();
			manager[json_data.type] = new wsod_chartrollovers();
			manager[json_data.type].InitializePopups(json_data.data, eventId, popupId, chartId);
			manager[json_data.type].AddRolloverData(json_data.data); 
//			wsod_InitializeChartRollovers._manager = manager;
		}
		else {
			$("#WSOD_P_Overview .chartModule span.psaChartRollover").addClass("hide"); //hide all rollovers (when no chart is available)
		}
	};
    wsod_chart._HandleRequestError = function(json_data, status) {
		//need to add dialog
		//alert("error");
	};

    wsod_chart.RetrieveChartDefinition = function($elDef, $el, timeframe) {
		var tf = timeframe || $el.attr("timeframe");
		var charttype = $elDef.attr("charttype");
		var id = $elDef.attr("id");
		var date = wsod.jsToMsDate(new Date()) - tf;
		var self = this;
		var interestdate = self.priceAnnDates;
		var interestArray = [];

		if (interestdate != null) {
		    for (var i = 0; i < interestdate.length; i++) {
		        var psaDate = tf === 1 ? interestdate[i].Date.toFixed(2) : interestdate[i].Date.toFixed(0);
		        interestArray.push(psaDate);
			}
			interestArray = interestArray.join("|");
		}

		this.selectedMultiTimeframe = tf;

		var json = {
			timeframe: tf
			, date: date
			, interestdate: interestArray
		};

		if (charttype == "HistoricalPriceComparisonChart" || charttype == "SnapshotChart") {
			var syms = $elDef.attr("chartsymbols") || $elDef.attr("chartsymbol");
			json.symbols = (syms) ? jQuery.fromJSON(syms) : [];

		} else if (charttype == "PortfolioChart") {

			if ($('#wsod_performanceChart').length) {

				var issues = [];
				var colors = [];

				// portfolio
				json.portfolio = $('#wsod_performanceChart').attr('portfolio');
				colors.push($('#WSOD_P_PortfolioCharts table.holdingsTable tr:last span.key').attr('color'));

				// issues
				$('#WSOD_P_PortfolioCharts table.chartTable input:checked').each(function() {
					issues.push($(this).val());
					colors.push($(this).parent().find('span.key').attr('color'));
				});

				json.logarithmic = $('#WSOD_P_PortfolioCharts div.logarithmic input').prop('checked');
				json.issues = issues.join('|');
				json.colors = colors.join('|');
				$('#wsod_performanceChart').attr('issues', json.issues);
			}

		} else {

			json.issueId = $elDef.attr("chartsymbol");
		}

		if (tf == "lasttrade" || tf == "sinceadded") {
			json.date = $elDef.attr(tf);
		}

		//var rollovers = wsod_InitializeChartRollovers.GetManager()[charttype];
		//if (rollovers && rollovers._popupData) {
		//	json.interestdate = rollovers._popupData.Date;
		//}

		var data = {
			charttype: charttype
			, id: id
			, json: json
		};

        return data;
	};
    /*Needed for MultiCharts so that timeframe navs change*/
	wsod_chart.HandleSelectedTimeframe = function($container, $clicked) {
		$container.find("." + this.SELECTED_CLASS).swapClass(this.SELECTED_CLASS);
		$clicked.swapClass(this.SELECTED_CLASS);
	};

    wsod_chart.GetSelectedMultiChartTimeframe = function() {
		if (this.selectedMultiTimeframe == null) {
			this.selectedMultiTimeframe = $(".chartContainer .chartDefinition ." + this.SELECTED_CLASS).attr("timeframe");
		}
		return this.selectedMultiTimeframe;
	};

    wsod_chart.GetCachedElement = function(objToCacheIn, elementId) {
		if (!objToCacheIn[elementId]) {
			objToCacheIn[elementId] = $("#" + elementId);
		}
		return objToCacheIn[elementId];
	};

    wsod_chart.lineChartCallback = function(point, value, canvasEl) {

		if (!canvasEl) {
			return;
		}

		var overlay = canvasEl.parent().children('span');
		var overlayMiniChartPopup = $('#wsod_perShareInfoPopUp');
		var overlayMiniChartPopupSpan = $('#wsod_minichartPopUp');
		var img = canvasEl.parent();
		var pos = img.position();
		var top = pos.top, left = pos.left;

		if (!point) {
			overlay.hide();
			overlayMiniChartPopup.hide();
			canvasEl.css({ 'cursor': 'default' });
		} else {
			var textList = wsod_GetMiniChartTextDisplay();
			var $table = canvasEl.parents(".miniChart");
			var magnitude = $table.attr("magnitude");
			var dataType = $table.attr("dataType");

			var chartText = {
				valueText: "--",
				dateText: "--"
			};

			if (textList[0].Date.length == 5) {	
				chartText = wsod_chart.returnFivePointChartText(textList, dataType,point);
			} else {
				chartText = wsod_chart.returnFourPointChartText(textList, dataType,point);
			}

			canvasEl.css({ 'cursor': 'pointer' });
			overlay.css({ 'top': point.y - 42, 'left': point.x });

			overlay.html("<span class='date'>" + chartText.dateText + "</span>" + "<span class='value'>" + chartText.valueText + "</span>");
			overlay.show();

			overlayMiniChartPopup.css({ 'top': top + point.y - 45, 'left': left + point.x - 10 });
			overlayMiniChartPopupSpan.html("<span class='date'>" + chartText.dateText + "</span>" + "<span class='value'>" + chartText.valueText + "</span>");
			overlayMiniChartPopup.show();
		}
	};


    wsod_chart.returnFourPointChartText = function(textList, dataType, point) {
		var chartText = {};
		$.each(textList, function(index, value) {
			if (value.Value == dataType) {
				switch (point.x) {
					case 3:
						chartText.valueText = value.Label[0];
						chartText.dateText = value.Date[0];
						break;
					case 31:
						chartText.valueText = value.Label[1];
						chartText.dateText = value.Date[1];
						break;
					case 59:
						chartText.valueText = value.Label[2];
						chartText.dateText = value.Date[2];
						break;
					case 76:
						chartText.valueText = value.Label[3];
						chartText.dateText = value.Date[3];
						break;
				}
			}
		});

		return chartText;
	};


    wsod_chart.returnFivePointChartText = function(textList, dataType, point) {
		var chartText = {};	
		$.each(textList, function(index, value) {
			if (value.Value == dataType) {
				switch (point.x) {
					case 3:
						chartText.valueText = value.Label[0];
						chartText.dateText = value.Date[0];
						break;
					case 24:
						chartText.valueText = value.Label[1];
						chartText.dateText = value.Date[1];
						break;
					case 45:
						chartText.valueText = value.Label[2];
						chartText.dateText = value.Date[2];
						break;
					case 66:
						chartText.valueText = value.Label[3];
						chartText.dateText = value.Date[3];
						break;
					case 76:
						chartText.valueText = value.Label[4];
						chartText.dateText = value.Date[4];
						break;
				}
			}		
		});

		return chartText;
	};


    wsod_chart.initPortfolioChart = function() {

		if ($('#WSOD_P_PortfolioCharts').length) {
			$('#WSOD_P_PortfolioCharts input:checked').attr('checked', true);
			$('#WSOD_P_PortfolioCharts input').click(function() {

				var selected = $('#WSOD_P_PortfolioCharts .TimeframeMenu li.selected a');
				if (selected.length) {
					selected.trigger('click');
				}
			});
		}
	};

	wsod_chart.disabledPortfolioComparisonChartInputs = false;
	wsod_chart.initPortfolioComparisonChart = function() {

		if ($('#WSOD_M_PerformanceWeightedChart').length) {
			$('#WSOD_M_PerformanceWeightedChart input').attr('checked', false);
			
			$('#WSOD_M_PerformanceWeightedChart input').click(function(e) {
				var el = $(e.target);
				
				if(el.is(":not(:checked)"))
				{
					var key = $(this).parent().find('div.key');
					wsod_chart.chartLineColors.push(key.attr('color'));

					key.attr('color', '#FFF');
					key.css('color', '#FFF');
				}

				if(!wsod_chart.chartLineColors.length)
				{
					el.attr('checked', false);
					
					return false;
				}
				else if(wsod_chart.disabledPortfolioComparisonChartInputs)
				{
					$('#WSOD_M_PerformanceWeightedChart td.disabled').removeClass('disabled');
					wsod_chart.disabledPortfolioComparisonChartInputs = false;
				}

				if(el.is(":checked"))
				{
					var key = $(this).parent().find('div.key');
					var color = wsod_chart.chartLineColors.pop();

					key.attr('color', color);
					key.css('color', '#' + color);

					if(!wsod_chart.chartLineColors.length)
					{
						$('#WSOD_M_PerformanceWeightedChart input:not(:checked)').each(function(){
							$(this).parents('td').addClass('disabled');
						});
						wsod_chart.disabledPortfolioComparisonChartInputs = true;
					}
				}

				var portfolios = [];
				var colors = [];

				$('#WSOD_M_PerformanceWeightedChart input:checked').each(function() {
					portfolios.push($(this).val());
					colors.push('#' + $(this).parent().find('div.key').attr('color'));
				});

				var benchmark = $('#WSOD_M_PerformanceWeightedChartBenchmark div.key');
				if (benchmark.length) {
					colors.push(benchmark.attr('color'));
				}

				wsod.showAjaxLoader($('#WSOD_M_PerformanceWeightedChart img'));
				wsod.load({
					portfolios: portfolios.join('|')
						, issues: '568509' // ASX 200
						, colors: colors.join('|')
				}
					, "Api/PortfolioComparisonChart"
					, function(data, status, xhr) {

						wsod.hideAjaxLoader($('#WSOD_M_PerformanceWeightedChart img'));
						if (data.src) {
							$('#WSOD_M_PerformanceWeightedChart img').attr('src', data.src);
						}
					}
					, function(xhr, status, err) {

						wsod.hideAjaxLoader($('#WSOD_M_PerformanceWeightedChart img'));
					}
					, null
					, null
				);
			});
		}
	};

    wsod_chart.initCircleCharts = function() {

		$(document).ready(function() {

			var radius = 20;

			$('div.wsod div.circleChart').each(function() {

				var total = parseInt($(this).find('div.data').children('span.total').text());
				var change = parseFloat($(this).find('div.data').children('span.change').text());

				if (change < 0) {
					$(this).find('span.change').addClass('neg arrow');
				} else if (change > 0) {
					$(this).find('span.change').addClass('pos arrow');
				}

				var canvasElem = document.createElement('canvas');
				canvasElem.setAttribute("width", 2 * radius);
				canvasElem.setAttribute("height", 2 * radius);

				// you need to add the canvas element to the document before doing anything else.
				$(this).find('div.chart').append(canvasElem);

				// if it is IE...
				if (typeof G_vmlCanvasManager != 'undefined') {
					// you have to reassign the variable to the new element created by initElement
					canvasElem = G_vmlCanvasManager.initElement(canvasElem);
				}

				var ctx = canvasElem.getContext('2d');

				ctx.beginPath();
				ctx.fillStyle = change >= 0 ? "#8cbd45" : '#aa2526'; // green : red
				ctx.arc(radius, radius, radius, 0, Math.PI * 2, true);
				ctx.closePath();
				ctx.fill();

				change = Math.abs(change);

				if (change < 100) {

					ctx.beginPath();
					ctx.fillStyle = "#fff"; // white
					ctx.arc(radius, radius, (radius - (radius * change / 100)) + 1, 0, Math.PI * 2, true);
					ctx.closePath();
					ctx.fill();

					ctx.beginPath();
					ctx.fillStyle = "#606e79"; // grey
					ctx.arc(radius, radius, (radius - (radius * change / 100)), 0, Math.PI * 2, true);
					ctx.closePath();
					ctx.fill();
				}
			});
		});
	};

    //Basic Chart Rollover Functions
	wsod_InitializeChartRollovers.GetManager = function() {
		if (!this.manager) {
			this.manager = {};
		}
		return this.manager;
	};

    $.extend(wsod_chartrollovers.prototype, wsod_popupRollover);
	wsod_chartrollovers.prototype.base = wsod_popupRollover;

	wsod_chartrollovers.prototype.AddRolloverData = function(data) {
		if (data) {			
			for (i = 0; i < data.length; i++) {
				this._popupData = data[i];	
				var self = this;	
				this.PositionRollover();
			}
		}
	};


    wsod_chartrollovers.prototype.PositionRollover = function() {
		var yPadding = 10;
		if (this._popupData.X > 0 && this._popupData.Y > 0) {
			var pos = this._$chartImg.offset();
			var x = this._popupData.X;
			var y = this._popupData.Y + yPadding;
			this._$eventIcon.removeClass("hide");
			this._$eventIcon.css({ left: x - (this._$eventIcon.width() / 2), top: y - (this._$eventIcon.height() / 2) });

		} else {
			if (this._$eventIcon) {
				this._$eventIcon.addClass("hide");
			}
		}
	};

    wsod_chartrollovers.prototype.InitializePopups = function(data, eventId, eventPopupId, chartId) {
		if (data) {
			for (i = 0; i < data.length; i++) {
				this._popupData = data[i];
				this._$eventIcon = $("#" + eventId + i);
				this._$eventPopup = $("#" + eventPopupId);

				if (this._$eventIcon.length) {
					this._$chartImg = $("#" + chartId);

					var self = this;
					this.PositionRollover();
				}
			}
		}
	};

    /**************************************************
	* Portfolio Holdings Perf. Chart Hover Functions  *
	**************************************************/

	wsod_chart.PortfolioChartOver = function(el) {
		el = $(el);
		var img = $("#wsod_allocationChart");
		var pop = $("#wsod_portfolioChartPopUp");
		var span = $("#wsod_portfolioPopUp");
		var pos = img.position();

		var barPos = el.attr("coords");
		var change = el.attr("change");
		var flag = el.attr("flag");
		var tempBar = barPos.split(",");
		var barX = tempBar[0], barTopY = tempBar[1], barBottomY = tempBar[3];
		var top = pos.top, left = pos.left;
		var xTop = Number(barX) + Number(left);
		var yTop = Number(barTopY) + Number(top);
		var yBottom = Number(barBottomY) + Number(top);
		var yNegOffset = yBottom + 8;
		var yPosOffset = yTop - 45;

		span.text(change);
		wsod.show(pop);

		if (flag == 0) {
			pop.css({ 'top': yNegOffset, 'left': xTop });
		}
		else {
			pop.css({ 'top': yPosOffset, 'left': xTop });
		}
	};

    wsod_chart.PortfolioChartOut = function(el) {
		var pop = $("#wsod_portfolioChartPopUp");
		wsod.hide(pop);
	};

    wsod_chart.PerfBarChartOver = function(el, x1, y0, h, buy, hold, sell, timeframe, header) {
		x1 = parseFloat(x1); y0 = parseFloat(y0);
		wsod_popupInternals.clearPopup();
		var base = wsod_popupInternals.getBasePop();
		base.addClass("perfBarChart");

		wsod_popupInternals.setContent(
			wsod_chart.getPerfBarChartContent(buy, hold, sell, timeframe, header)
		);

		//ISS162410 Ie7 places image maps at the top left of the page instead of over the image
		//, so grabbing parent div and adjusting
		var $p = $(el).closest("div");
		wsod_popupInternals.showPopup();
		wsod_popupRollover.PositionPopup($p, x1, y0 + 30, -8, -8, h);
	};

    wsod_chart.getPerfBarChartContent = function(buy, hold, sell, timeframe, header) {
		var temp = $("#wsod_perfBarChartTemp").clone(); //popup template html
		temp.removeAttr("id");
		var table = temp.find("table");
		var letters = timeframe.split(" ");
		var first = letters[0];
		var $content = $(table).find("td.perfChartTimeFrame");
		if (first == "1") {
			$content.text(timeframe);
		}
		else {
			$content.text(timeframe + "s"); //TODO: this should be done by Nick on chart output
		}

		temp.find("h3").text(header);
		table.find("td.buyRating").text(buy);
		table.find("td.holdRating").text(hold);
		table.find("td.sellRating").text(sell);

		wsod.show(temp);
		return temp;
	};

    wsod_chart.PerfBarChartOut = function() {
		wsod_popupInternals.hidePopup();
	};

    //Profile Bar charts rollover popup
	wsod_chart.showProfilePopup = function(el)
	{
		var $el = $(el).closest(".profileRollover");
		var $pop = $("#wsod_profilePopup");
		var $txt = $pop.find("span.color");
		var val = parseFloat($el.attr("val"));
		
		if (val > 0) {
			$txt.removeClass("unch pos neg").addClass("pos");
			$txt.text("+"+val+"%");
		} else if (val < 0) {
			$txt.removeClass("unch pos neg").addClass("neg");
			$txt.text(val+"%");
		}

		wsod.show($pop);
		var p = $el.position();
		var y = p.top - ($pop.height() || 0) - 5;
		var x = p.left - (($pop.width() || 0) / 2);
		$pop.css({ 'top': y, 'left': x });
	};
    wsod_chart.hideProfilePopup = function()
	{
		var $pop = $("#wsod_profilePopup");
		wsod.hide($pop);
	};

})($);

(function ($) {
    $.fn.swapClass = function (classname) {
        if (this.hasClass(classname)) {
            return this.removeClass(classname);
        } else {
            return this.addClass(classname);
        }
    };
})($);
